import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  border: 1px solid ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  line-height: 30px;\n  color: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      font-weight: 600;\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  color: ", ";\n\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(", ", 1fr);\n  gap: 10px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 115px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { theme } from '../../theme';
import { css } from '../../utils/styling/styled-components';
import { Bodytext, Heading } from '../../Typography';
import styled from '../../utils/styling/styled-components';
var Container = styled.div(_templateObject());
var ValueContainer = styled.div(_templateObject2());
var Section = styled.div(_templateObject3(), function (props) {
  return props.columns;
});
var Label = styled(Bodytext)(_templateObject4(), function (props) {
  return props.color;
}, function (props) {
  return props.bold && css(_templateObject5());
});
var Value = styled(Heading)(_templateObject6(), function (props) {
  return props.columns === 1 ? '22px' : '18px';
}, function (props) {
  return props.theme.colors.slate;
});
var Divider = styled.hr(_templateObject7(), function (props) {
  return props.theme.colors.ivory;
});

var Content = function Content(_ref) {
  var contentGroup = _ref.contentGroup;
  return /*#__PURE__*/React.createElement(Section, {
    columns: contentGroup.length
  }, contentGroup.map(function (content) {
    var _content$testId, _content$color;

    return /*#__PURE__*/React.createElement(ValueContainer, {
      key: content.label,
      "data-testid": (_content$testId = content.testId) !== null && _content$testId !== void 0 ? _content$testId : "".concat(content.label.toLowerCase(), "_value")
    }, /*#__PURE__*/React.createElement(Value, {
      columns: contentGroup.length
    }, content.value), /*#__PURE__*/React.createElement(Label, {
      bold: !!content.bold,
      color: (_content$color = content.color) !== null && _content$color !== void 0 ? _content$color : theme.colors.green
    }, content.label));
  }));
};

export var SplitContent = function SplitContent(_ref2) {
  var className = _ref2.className,
      topContent = _ref2.topContent,
      bottomContent = _ref2.bottomContent;
  return /*#__PURE__*/React.createElement(Container, {
    className: className
  }, /*#__PURE__*/React.createElement(Content, {
    contentGroup: topContent
  }), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Content, {
    contentGroup: bottomContent
  }));
};